import React, { useEffect, useState } from "react";
import DropdownTrigger from "./DropdownTrigger";
import DropdownLists from "./DropdownLists";

const SearchableDropdown = (props) => {
  const {
    name = null,
    labels = [],
    selectedValue = [],
    onChange = () => {},
    icon,
    disabled = false,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(selectedValue);
  const [pendingValue, setPendingValue] = useState([]);

  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue]);

  const handleClick = (event) => {
    setPendingValue(value);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setValue(pendingValue);
    if (anchorEl) {
      anchorEl.focus();
    }
    setAnchorEl(null);
    if (!areObjectsEqual(pendingValue, value)) {
      onChange(pendingValue, name);
    }
  };

  const areObjectsEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;

    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!keys2.includes(key) || !areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  };

  const open = Boolean(anchorEl);
  const id = open ? "github-label" : undefined;

  return (
    <>
      <DropdownTrigger
        id={id}
        handleClick={handleClick}
        value={value}
        icon={icon}
        disabled={disabled}
      />
      <DropdownLists
        id={id}
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        pendingValue={pendingValue}
        setPendingValue={setPendingValue}
        labels={labels}
        value={value}
      />
    </>
  );
};

export default SearchableDropdown;
